import { gql } from "@apollo/client";

export const GET_LANGUAGES = gql`
  {
    languageCollection {
      items {
        code
        flag
        title
        active
      }
    }
  }
`;

export const GET_LANGUAGE_CONTENT_PART_1 = gql`
  query ($code: String!) {
    languageCollection(where: { code: $code }, limit: 1) {
      items {
        cookieBanner {
          title
          description {
            json
          }
          allowNeccessary
          allowAll
          close
        }
        header {
          logo {
            title
            description
            contentType
            fileName
            size
            url
            width
            height
          }
          projects
          references
          aboutUs
          contact
        }
        footer {
          logo {
            title
            description
            contentType
            fileName
            size
            url
            width
            height
          }
          projects
          references
          aboutUs
          contact
          followUs
          socialConnectionsCollection {
            items {
              title
              logo {
                title
                description
                contentType
                fileName
                size
                url
                width
                height
              }
              url
            }
          }
          contactUs
          phoneNumber
          email
          legalInfo
          termsOfUse
          copyrightInfo
        }
        home {
          titleText
          titleImage {
            title
            description
            contentType
            fileName
            size
            url
            width
            height
          }
          promoVideoDesktop {
            title
            description
            contentType
            fileName
            size
            url
            width
            height
          }
          promoVideoMobile {
            title
            description
            contentType
            fileName
            size
            url
            width
            height
          }
          projectsCollection {
            items {
              id
              title
              description {
                json
              }
              reverseLayout
              position
              marketingClaimsCollection(limit: 5) {
                items {
                  number
                  text {
                    json
                  }
                }
              }
              colorInvert
              callToAction
              marketingImageXs {
                title
                description
                contentType
                fileName
                size
                url
                width
                height
              }
              marketingImageSm {
                title
                description
                contentType
                fileName
                size
                url
                width
                height
              }
              marketingImageMd {
                title
                description
                contentType
                fileName
                size
                url
                width
                height
              }
              marketingImageLg {
                title
                description
                contentType
                fileName
                size
                url
                width
                height
              }
              marketingImageXl {
                title
                description
                contentType
                fileName
                size
                url
                width
                height
              }
            }
          }
          project
          projectsAction
          claimsBannerCollection {
            items {
              title
              description {
                json
              }
              icon {
                title
                description
                contentType
                fileName
                size
                url
                width
                height
              }
            }
          }
          claimsBannerPosition
        }
      }
    }
  }
`;

export const GET_LANGUAGE_CONTENT_PART_2 = gql`
  query ($code: String!) {
    languageCollection(where: { code: $code }, limit: 1) {
      items {
        contact {
          title
          # contactsLabel
          # phoneLabel
          # phone
          # emailLabel
          # email
          # addressLabel
          # address {
          #   json
          # }
          addressMapUrl
          mediaContactLabel
          mediaContactEmail
          mediaContactPhone
          bottomBannerLabel
          bottomBannerAction
        }
        references {
          title
          publicSectorLabel
          publicSectorCollection {
            items {
              sys {
                id
              }
              name
              url
              logo {
                title
                description
                contentType
                fileName
                size
                url
                width
                height
              }
            }
          }
          privateSectorLabel
          privateSectorCollection {
            items {
              sys {
                id
              }
              name
              url
              logo {
                title
                description
                contentType
                fileName
                size
                url
                width
                height
              }
            }
          }
          partnershipLabel
          partnershipCollection {
            items {
              sys {
                id
              }
              name
              url
              logo {
                title
                description
                contentType
                fileName
                size
                url
                width
                height
              }
            }
          }
          bottomBannerLabel
          bottomBannerAction
        }
        legal {
          legalInfoLabel
          legalInfoContent {
            json
          }
          termsOfUseLabel
          termsOfUseContent {
            json
          }
        }
        aboutUs {
          title
          missionLabel
          missionDescription {
            json
          }
          valuesLabel
          valuesCollection(limit: 10) {
            items {
              title
              description {
                json
              }
              icon {
                title
                description
                contentType
                fileName
                size
                url
                width
                height
              }
            }
          }
          historyLabel
          historyDescription {
            json
          }
          marketingClaimsLabel
          marketingClaimsCollection(limit: 10) {
            items {
              number
              text {
                json
              }
            }
          }
          solutionFeaturesLabel
          solutionFeaturesCollection {
            items {
              title
              description {
                json
              }
            }
          }
          certificatesLabel
          certificatesCollection(limit: 20) {
            items {
              title
              description {
                json
              }
              logo {
                title
                description
                contentType
                fileName
                size
                url
                width
                height
              }
              url
              file {
                title
                description
                contentType
                fileName
                size
                url
                width
                height
              }
            }
          }
          bottomBannerLabel
          bottomBannerAction
        }
      }
    }
  }
`;

export const GET_LANGUAGE_CONTENT_PART_3 = gql`
  query ($code: String!) {
    languageCollection(where: { code: $code }, limit: 1) {
      items {
        solutions {
          title
          secondaryProjectsTitle
          solutionsCollection {
            items {
              primaryProject {
                id
                title
                description {
                  json
                }
                descriptionShort {
                  json
                }
                attributes {
                  json
                }
                readingTime
                reverseLayout
                position
                marketingClaimsCollection(limit: 2) {
                  items {
                    number
                    text {
                      json
                    }
                  }
                }
                colorInvert
                callToAction
                marketingImageXs {
                  title
                  description
                  contentType
                  fileName
                  size
                  url
                  width
                  height
                }
                marketingImageSm {
                  title
                  description
                  contentType
                  fileName
                  size
                  url
                  width
                  height
                }
                marketingImageMd {
                  title
                  description
                  contentType
                  fileName
                  size
                  url
                  width
                  height
                }
                marketingImageLg {
                  title
                  description
                  contentType
                  fileName
                  size
                  url
                  width
                  height
                }
                marketingImageXl {
                  title
                  description
                  contentType
                  fileName
                  size
                  url
                  width
                  height
                }
              }
              # WARNING: Secondary projects list is limited to maximum of 10 projects due to performance reasons.
              secondaryProjectsCollection(limit: 10) {
                items {
                  id
                  title
                  description {
                    json
                  }
                  descriptionShort {
                    json
                  }
                  attributes {
                    json
                  }
                  readingTime
                  reverseLayout
                  position
                  marketingClaimsCollection(limit: 2) {
                    items {
                      number
                      text {
                        json
                      }
                    }
                  }
                  colorInvert
                  callToAction
                  marketingImageXs {
                    title
                    description
                    contentType
                    fileName
                    size
                    url
                    width
                    height
                  }
                  marketingImageSm {
                    title
                    description
                    contentType
                    fileName
                    size
                    url
                    width
                    height
                  }
                  marketingImageMd {
                    title
                    description
                    contentType
                    fileName
                    size
                    url
                    width
                    height
                  }
                  marketingImageLg {
                    title
                    description
                    contentType
                    fileName
                    size
                    url
                    width
                    height
                  }
                  marketingImageXl {
                    title
                    description
                    contentType
                    fileName
                    size
                    url
                    width
                    height
                  }
                }
              }
            }
          }
          bottomBannerLabel
          bottomBannerAction
          bottomBannerLabelProject
          bottomBannerActionProject
        }
      }
    }
  }
`;
